// StepBasicInfo.tsx
import React from "react";
import {
	FormGroup,
	Label,
	Input,
	FormText
} from "reactstrap";

interface BasicInfo {
	name: string;
	description: string;
	campaignType: "MARKETING" | "TRANSACTIONAL";
}

interface Props {
	data: BasicInfo;
	onChange: (d: BasicInfo) => void;
	onNext: () => void;
}

const StepBasicInfo: React.FC<Props> = ({ data, onChange, onNext }) => {
	const { name, description, campaignType } = data;

	return (
		<>
			{/* ── Name ─────────────────────────────────────────── */}
			<FormGroup className="mb-4">
				<Label for="campaign-name" className="fw-semibold">
					Campaign Name
				</Label>
				<Input
					id="campaign-name"
					value={name}
					onChange={e => onChange({ ...data, name: e.target.value })}
					placeholder="e.g. Summer Promo 2025"
				/>
				<FormText color="muted">
					Give your campaign a clear, memorable name so you can find it later.
				</FormText>
			</FormGroup>

			{/* ── Description ──────────────────────────────────── */}
			<FormGroup className="mb-4">
				<Label for="campaign-description" className="fw-semibold">
					Description
				</Label>
				<Input
					type="textarea"
					id="campaign-description"
					value={description}
					onChange={e => onChange({ ...data, description: e.target.value })}
					placeholder="Optional: internal notes or objectives"
					rows={3}
				/>
				<FormText color="muted">
					This won’t be sent to recipients—only your team sees it.
				</FormText>
			</FormGroup>

			{/* ── Type ──────────────────────────────────────────── */}
			<FormGroup className="mb-4">
				<Label className="fw-semibold mb-2">Campaign Type</Label>
				<div className="d-flex flex-wrap gap-3">
					<div className="form-check">
						<Input
							type="radio"
							name="campaignType"
							id="type-marketing"
							className="form-check-input"
							checked={campaignType === "MARKETING"}
							onChange={() => onChange({ ...data, campaignType: "MARKETING" })}
						/>
						<Label for="type-marketing" className="form-check-label ms-2 mb-0">
							Marketing
						</Label>
					</div>
					<div className="form-check">
						<Input
							type="radio"
							name="campaignType"
							id="type-transactional"
							className="form-check-input"
							checked={campaignType === "TRANSACTIONAL"}
							onChange={() => onChange({ ...data, campaignType: "TRANSACTIONAL" })}
						/>
						<Label for="type-transactional" className="form-check-label ms-2 mb-0">
							Transactional
						</Label>
					</div>
				</div>
				<FormText color="muted" className="mt-2">
					“Transactional” messages are triggered by user actions (receipts, alerts); “Marketing” go to a broad audience.
				</FormText>
			</FormGroup>
		</>
	);
};

export default StepBasicInfo;
